/* MAIN */
const castArray = (value) => {
    return Array.isArray(value) ? value : [value];
};
const isFunction = (value) => {
    return (typeof value === 'function');
};
/* EXPORT */
export { castArray, isFunction };
